import { useEffect, useState } from "react";
import { FileInput } from "../theme/Component/FileInput";
import { BasicButton } from "../theme/Component/BasicButton";
import { EP02 } from "./CustomFormNew/CustomForms/Compras/EPREVIO/EP02";
import { EP03 } from "./CustomFormNew/CustomForms/Compras/EPREVIO/EP03";
import { ObsUpdateAdquisitionItem } from "./CustomFormNew/CustomForms/Compras/BaseFormsCompras/ObsUpdateAdquisitionItem";
import { EP06 } from "./CustomFormNew/CustomForms/Compras/EPREVIO/EP06";
import { BPM001 } from "./CustomFormNew/CustomForms/BaseForm/BPM001";
import { RenderForm } from "../theme/Component/RenderForm";
import useDataBean from "../../core/services/dataBean/useDataBean";
import { _Inbox, _single } from "../../core/services/dataBean/EntityCatalog";
import { SO004 } from "./CustomFormNew/CustomForms/Compras/SOLOFERTA/SO004";
import { BudgetRPFactory } from "../contabilidad/budgetRPFactory/BudgetRPFactory";
import { BudgetCDPFactory } from "../contabilidad/BudgetCDPFactory/BudgetCDPFactory";
import { SACDP001 } from "./CustomFormNew/CustomForms/Compras/SolicitudCDP/SACDP001";
import { BPM002 } from "./CustomFormNew/CustomForms/BaseForm/BPM002";
import { SACDP002 } from "./CustomFormNew/CustomForms/Compras/SolicitudCDP/SACDP002";
import { SACDP003 } from "./CustomFormNew/CustomForms/Compras/SolicitudCDP/SACDP003";
import { SOP001 } from "./CustomFormNew/CustomForms/Compras/STARTSOLOP/SOP001";
import { SOP002 } from "./CustomFormNew/CustomForms/Compras/STARTSOLOP/SOP002";
import { SOP003 } from "./CustomFormNew/CustomForms/Compras/STARTSOLOP/SOP003";
import { SOP004 } from "./CustomFormNew/CustomForms/Compras/STARTSOLOP/SOP004";
import { SOP005 } from "./CustomFormNew/CustomForms/Compras/STARTSOLOP/SOP005";
import { SOP006 } from "./CustomFormNew/CustomForms/Compras/STARTSOLOP/SOP006";
import { SOP007 } from "./CustomFormNew/CustomForms/Compras/STARTSOLOP/SOP007";
import { SOP008 } from "./CustomFormNew/CustomForms/Compras/STARTSOLOP/SOP008";
import { CC001 } from "./CustomFormNew/CustomForms/CreditoyCartera/CC001";
import { CC002 } from "./CustomFormNew/CustomForms/CreditoyCartera/CC002";
import { SOP009 } from "./CustomFormNew/CustomForms/Compras/STARTSOLOP/SOP009";
import { SOP010 } from "./CustomFormNew/CustomForms/Compras/STARTSOLOP/SOP010";
import { SP001 } from "./CustomFormNew/CustomForms/Compras/solicitudPresupuesto/SP001";
import { SP002 } from "./CustomFormNew/CustomForms/Compras/solicitudPresupuesto/SP002";
import { BPM003 } from "./CustomFormNew/CustomForms/BaseForm/BPM003";
import { BPM004 } from "./CustomFormNew/CustomForms/BaseForm/BPM004";
import { BPM005 } from "./CustomFormNew/CustomForms/BaseForm/BPM005";
import { SOP011 } from "./CustomFormNew/CustomForms/Compras/STARTSOLOP/SOP011";
import { SO003 } from "./CustomFormNew/CustomForms/Compras/SOLOFERTA/SO003";
import { BPM006 } from "./CustomFormNew/CustomForms/BaseForm/BPM006";
import { SO006 } from "./CustomFormNew/CustomForms/Compras/SOLOFERTA/SO006";
import { BPM007 } from "./CustomFormNew/CustomForms/BaseForm/BPM007";
import { COST001 } from "./CustomFormNew/CustomForms/Compras/CostStudy/COST001";
import { SCVA001 } from "./CustomFormNew/CustomForms/TalentoHumano/SCVA001";
import { SCVA002 } from "./CustomFormNew/CustomForms/TalentoHumano/SCVA002";
import { SCVA003 } from "./CustomFormNew/CustomForms/TalentoHumano/SCVA003";
import { SOP012 } from "./CustomFormNew/CustomForms/Compras/STARTSOLOP/SOP012";
import { THV001 } from "./CustomFormNew/CustomForms/TalentoHumano/THV001";
import { IMP001 } from "./CustomFormNew/CustomForms/Compras/ImportCostSettlement/IMP001";
import { EXP001 } from "./CustomFormNew/CustomForms/Compras/Exportations/EXP001";
import { DLC001 } from "./CustomFormNew/CustomForms/Compras/ImportDeclaration/DLC001";
import { CONT001 } from "./CustomFormNew/CustomForms/Compras/ImportContracts/CONT001";
import { TCN001 } from "./CustomFormNew/CustomForms/Compras/TotalControlNationalizationCustomBondedWarehouse/TCN001";
import { CC003 } from "./CustomFormNew/CustomForms/CreditoyCartera/CC003";
import { CC004 } from "./CustomFormNew/CustomForms/CreditoyCartera/CC004";
import { CC005 } from "./CustomFormNew/CustomForms/CreditoyCartera/CC005";
import { CC006 } from "./CustomFormNew/CustomForms/CreditoyCartera/CC006";
import { CC007 } from "./CustomFormNew/CustomForms/CreditoyCartera/CC007";
import { CC008 } from "./CustomFormNew/CustomForms/CreditoyCartera/CC008";
import { CC009 } from "./CustomFormNew/CustomForms/CreditoyCartera/CC009";
import { CC010 } from "./CustomFormNew/CustomForms/CreditoyCartera/CC010";
import { CC011 } from "./CustomFormNew/CustomForms/CreditoyCartera/CC011";
import { CC012 } from "./CustomFormNew/CustomForms/CreditoyCartera/CC012";
import { ACTINV001 } from "./CustomFormNew/CustomForms/Compras/StoreCodeForm/ACTINV001";
import { ACTEM001 } from "./CustomFormNew/CustomForms/Compras/StoreCodeFormsend/ACTEM001";
import { CETD001 } from "./CustomFormNew/CustomForms/Compras/cetd/CETD001";
import { DLC002 } from "./CustomFormNew/CustomForms/Compras/ImportDeclaration/DLC002";
import { ACTINV002 } from "./CustomFormNew/CustomForms/Compras/StoreCodeForm/ACTINV002";
import { THIN002 } from "./CustomFormNew/CustomForms/TalentoHumano/SolIncapacidad/THIN002";
import { THIN001 } from "./CustomFormNew/CustomForms/TalentoHumano/SolIncapacidad/THIN001";
import { EDD001 } from "./CustomFormNew/CustomForms/Compras/DescargueDirecto/EDD001";
import { MD001 } from "./CustomFormNew/CustomForms/Factory/MantenimientosDiarios/MD001";
import { MD002 } from "./CustomFormNew/CustomForms/Factory/MantenimientosDiarios/MD002";
import { MD003 } from "./CustomFormNew/CustomForms/Factory/MantenimientosDiarios/MD003";
import { MD004 } from "./CustomFormNew/CustomForms/Factory/MantenimientosDiarios/MD004";
import { MD005 } from "./CustomFormNew/CustomForms/Factory/MantenimientosDiarios/MD005";
import { MD006 } from "./CustomFormNew/CustomForms/Factory/MantenimientosDiarios/MD006";
import { MD007 } from "./CustomFormNew/CustomForms/Factory/MantenimientosDiarios/MD007";
import { MD008 } from "./CustomFormNew/CustomForms/Factory/MantenimientosDiarios/MD008";
import { MD009 } from "./CustomFormNew/CustomForms/Factory/MantenimientosDiarios/MD009";
import { MD010 } from "./CustomFormNew/CustomForms/Factory/MantenimientosDiarios/MD010";
import { MD011 } from "./CustomFormNew/CustomForms/Factory/MantenimientosDiarios/MD011";
import { DONCON001 } from "./CustomFormNew/CustomForms/Compras/DONCON001/DONCON001";
import { DDF001 } from "./CustomFormNew/CustomForms/Compras/DDF001/DDF001";
import { MD012 } from "./CustomFormNew/CustomForms/Factory/MantenimientosDiarios/MD012";
import { SOLCENCOST001 } from "./CustomFormNew/CustomForms/TalentoHumano/SolCreacionCentroCosto/SOLCENCOST001";
import { SOLCENCOST002 } from "./CustomFormNew/CustomForms/TalentoHumano/SolCreacionCentroCosto/SOLCENCOST002";
import { HD001 } from "./HelpDesk/HD/HD001";
import { HD002 } from "./HelpDesk/HD/HD002";
import { HD003 } from "./HelpDesk/HD/HD003";
import { TEST001 } from "./Encuesta/TEST001";
import { AOP001 } from "./CustomFormNew/CustomForms/Compras/UpdatePayOrder/AOP001";
import { AOP002 } from "./CustomFormNew/CustomForms/Compras/UpdatePayOrder/AOP002";
import { TURNO001 } from "./CustomFormNew/CustomForms/Compras/turno/TURNO001";
import { SPAA001 } from "./CustomFormNew/CustomForms/Compras/NuevaNecesidad/SPAA001";
import { SPAA002 } from "./CustomFormNew/CustomForms/Compras/NuevaNecesidad/SPAA002";
import { SPAA003 } from "./CustomFormNew/CustomForms/Compras/NuevaNecesidad/SPAA003";
import { BPM008 } from "./CustomFormNew/CustomForms/BaseForm/BPM008";
import { PC001 } from "./CustomFormNew/CustomForms/Compras/SOLOFERTA/PC001";
import { SOLPER001 } from "./CustomFormNew/CustomForms/TalentoHumano/SOLPER/SOLPER001";
import { SOLPER002 } from "./CustomFormNew/CustomForms/TalentoHumano/SOLPER/SOLPER002";
import { SOLAUTSAL001 } from "./CustomFormNew/CustomForms/MantenimientosAlmacenes/SOLAUTSAL/SOLAUTSAL001";
import { SOLAUTSAL002 } from "./CustomFormNew/CustomForms/MantenimientosAlmacenes/SOLAUTSAL/SOLAUTSAL002";
import { SOLAUTSAL003 } from "./CustomFormNew/CustomForms/MantenimientosAlmacenes/SOLAUTSAL/SOLAUTSAL003";
import { SOLAUTSAL004 } from "./CustomFormNew/CustomForms/MantenimientosAlmacenes/SOLAUTSAL/SOLAUTSAL004";
import { ARCON001 } from "./CustomFormNew/CustomForms/Compras/ARCON/ARCON001";
import { ARCON002 } from "./CustomFormNew/CustomForms/Compras/ARCON/ARCON002";
import { SCVA004 } from "./CustomFormNew/CustomForms/TalentoHumano/SCVA004";
import { SOLCAP001 } from "./CustomFormNew/CustomForms/TalentoHumano/SolCapacitacion/SOLCAP001";
import { SOLCAP002 } from "./CustomFormNew/CustomForms/TalentoHumano/SolCapacitacion/SOLCAP002";
;


interface DynamicFormHandlerProps {
    procedure: any;
    formCode: string;
    procedureAction: any;
    updateForm: (data: any) => void;
}

interface Proccess {
    IDProcedureImp: number;
    Resumen: any;
    Props: any;
}

export const DynamicFormHandler = ({ formCode, procedureAction, updateForm, procedure }: DynamicFormHandlerProps) => {

    const [doc, setDoc] = useState<any>({});
    const { instance, setBean, bean } = useDataBean(_Inbox);
    const [process, setProcess] = useState<Partial<Proccess>>({

    });


    const updateDoc = () => {
        updateForm(doc);
    }

    useEffect(() => {
        getInfo()
    }, [procedureAction.IDProcedureImp])

    const getInfo = () => {
        instance.getRequestProcessBpmByImp(procedureAction.IDProcedureImp)
            .then((resp) => {
                let newProcess = { ...process, IDProcedureImp: resp.IDProcedureImp };

                if (resp.JSONProps) newProcess.Props = JSON.parse(resp.JSONProps);
                if (resp.JSONResume) newProcess.Resumen = JSON.parse(resp.JSONResume);

                setProcess(newProcess);
            })
            .catch(err => console.error("Error en actualizar la tabla", err));
    };

    // useEffect(() => {
    //     console.log(process)
    // }, [process])

    const pushProps = (objeto: any) => {
        // instance.pushRequestProcessBpm(procedureAction.IDProcedureImp, objeto, { disableSpinner: true }).then((resp) => {
        return instance.pushRequestProcessBpm(procedureAction.IDProcedureImp, objeto).then((resp) => {
            // console.log(resp)
        }).catch(err => { console.log("Error en actualizar la tabla", err) })
    }


    const pushResumeInfo = (objeto: any) => {

        // instance.pushResumeBpm(procedureAction.IDProcedureImp, _single.getAccountID(), `${objeto} - ${procedureAction.Name ? procedureAction.Name : "N/A"}`, { disableSpinner: true }).then((resp) => {
        instance.pushResumeBpm(procedureAction.IDProcedureImp, _single.getAccountID(), `${objeto} - ${procedureAction.Name ? procedureAction.Name : "N/A"}`).then((resp) => {
        }).catch(err => { console.log("Error en actualizar la tabla", err) })
    }

    switch (formCode) {

        //Estudio Previo
        case 'EP01':
            return (
                <div className="row">
                    <div className="col-md-12 d-flex justify-content-center">
                        <div className="row w-75">
                            <div className="col-md-12">
                                <FileInput
                                    label="Cargar Documento Requerido"
                                    onCreate={({ Media, MediaContext, Name }) =>
                                        setDoc?.({ ...doc, Media, MediaContext, Name })
                                    }
                                />
                            </div>
                            <div className="col-4 mt-2">
                                <BasicButton
                                    icon="ri-send-plane-2-line"
                                    clase="primary"
                                    eventClick={updateDoc}
                                >
                                    Cargar
                                </BasicButton>
                            </div>
                        </div>
                    </div>
                </div>
            );

        case 'EP02':
            return <EP02 exportMap={(data) => updateForm(data)} />;

        case "EP03":
            return <EP03 exportMap={(data) => updateForm(data)} />


        //Creacion de CDP dentro de flujos
        case "EP04":
            return <BudgetCDPFactory
                configProcedure={{
                    _exportMap: (data) => updateForm(data),
                    _procedure: procedureAction,
                    _pocessData: process,
                    _pushInfo: (map) => { pushResumeInfo(map) },
                    _pushProps: (map) => { pushProps(map) }
                }}
            />

        case "EP05":
            return <ObsUpdateAdquisitionItem stateChange={40} procedure={procedureAction} exportMap={(data) => { updateForm(data) }} />

        case 'EP06':
            return <EP06 procedure={procedureAction} exportMap={(data) => updateForm(data)} />;

        //Solicitud Oferta

        // case "SO001":
        //     return <ConfigurarOfertaBpm configProcedure={{
        //         _exportMap: (data) => updateForm(data),
        //         _procedure: procedureAction,
        //         _pocessData: process,
        //         _pushInfo: (map) => { pushResumeInfo(map) },
        //         _pushProps: (map) => { pushProps(map) }
        //     }} />

        // case "SO001":
        //     return <RenderForm idFormType={901} handleUpdate={(data) => updateForm(data)} />;

        case "SO003":
            //Selección Proveedor
            return <SO003 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "SO004S": //Registro de contrato (sin guardar)
            return <SO004
                onlyInfo
                configProcedure={{
                    _exportMap: (data) => updateForm(data),
                    _procedure: procedureAction,
                    _pocessData: process,
                    _pushInfo: (map) => { pushResumeInfo(map) },
                    _pushProps: (map) => { pushProps(map) }
                }} />;

        case "SO004C": //Registro de contrato
            return <SO004 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "SO005": // Asignacion de RP
            return <BudgetRPFactory
                configProcedure={{
                    _exportMap: (data) => updateForm(data),
                    _procedure: procedureAction,
                    _pocessData: process,
                    _pushInfo: (map) => { pushResumeInfo(map) },
                    _pushProps: (map) => { pushProps(map) }
                }}
            />;

        case "SO006": //Modificación Inicial
            return <SO006
                configProcedure={{
                    _exportMap: (data) => updateForm(data),
                    _procedure: procedureAction,
                    _pocessData: process,
                    _pushInfo: (map) => { pushResumeInfo(map) },
                    _pushProps: (map) => { pushProps(map) }
                }}
            />;

        case "PC001": //Confirmar Modalidad de Contratación 
            return <PC001
                configProcedure={{
                    _exportMap: (data) => updateForm(data),
                    _procedure: procedureAction,
                    _pocessData: process,
                    _pushInfo: (map) => { pushResumeInfo(map) },
                    _pushProps: (map) => { pushProps(map) }
                }}
            />;

        //Solicitud Orden de Pago

        case "SOP001":
            return <SOP001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;
        case "SOP012":
            return <SOP012 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "SOP002":
            return <SOP002 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "SOP003":
            return <SOP003 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "SOP004":
            return <SOP004 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;
        case "DONCON001":
            return <DONCON001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;
        case "DDF001":
            return <DDF001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;
        case "EDD001":
            return <EDD001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;
        case "COST001":
            return <COST001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;
        case "DLC001":
            return <DLC001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;
        case "DLC002":
            return <DLC002 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;
        case "IMP001":
            return <IMP001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;
        case "ACTINV001":
            return <ACTINV001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }
            } />;
        case "ACTINV002":
            return <ACTINV002 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }
            } />;
        case "ACTEM001":
            return <ACTEM001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }
            } />;
        case "CETD001":
            return <CETD001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }
            } />;
        case "EXP001":
            return <EXP001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "CONT001":
            return <CONT001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;
        case "TCN001":
            return <TCN001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;
        case "SOP005":
            return <SOP005 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "SOP006":
            return <SOP006 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "SOP007":
            return <SOP007 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "SOP008":
            return <SOP008 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;
        case "SOP009":
            return <SOP009 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;
        case "SOP010":
            return <SOP010 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;
        case "SOP011":
            return <SOP011 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        //cajas menores
        case "RCM001":
            return <RenderForm idFormType={901} handleUpdate={(data) => updateForm(data)} />;

        //Solicitud CDP - Forpo

        case "SACDP001":
            return <SACDP001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "SACDP002":
            return <SACDP002 procedure={procedureAction} exportMap={(data) => { updateForm(data) }} pushInfo={pushProps} pushResume={pushResumeInfo} />;

        case "SACDP003":
            return <SACDP003 procedure={procedureAction} exportMap={(data) => { updateForm(data) }} pushInfo={pushResumeInfo} pushProps={pushProps} />;
        case "SP001":
            return <SP001 procedure={procedureAction} exportMap={(data) => { updateForm(data) }} pushInfo={pushResumeInfo} pushProps={pushProps} />;
        case "SP002":
            return <SP002 props={process} procedure={procedureAction} exportMap={(data) => { updateForm(data) }} pushInfo={pushResumeInfo} pushProps={pushProps} />;

        // Solicitudes de Talento Humano

        case "THIN001": //=========> Formulario Solicitud de Incapacidad
            return <THIN001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "THIN002": //=========> Formulario Creacion de Incapacidad
            return <THIN002 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "SOLCENCOST001": //=========>  Aprobacion Creacion centro de costo
            return <SOLCENCOST001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "SOLCENCOST002": //=========> Formulario Creacion centro de costo
            return <SOLCENCOST002 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />


        case "SOLPER001": //Formulario de solicitud de permiso 
            return <SOLPER001
                configProcedure={{
                    _exportMap: (data) => updateForm(data),
                    _procedure: procedureAction,
                    _pocessData: process,
                    _pushInfo: (map) => { pushResumeInfo(map) },
                    _pushProps: (map) => { pushProps(map) }
                }}
            />;

        case "SOLPER002": //Formulario de Aprobacion o rechazo de permisos 
            return <SOLPER002
                configProcedure={{
                    _exportMap: (data) => updateForm(data),
                    _procedure: procedureAction,
                    _pocessData: process,
                    _pushInfo: (map) => { pushResumeInfo(map) },
                    _pushProps: (map) => { pushProps(map) }
                }}
            />;

        //Solicitud Credito Forpo

        case "CC001": //=========> Formulario Datos Basicos
            return <CC001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />
        case "CC002": //=========> Valores Credito
            return <CC002 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "CC003": //=========> Decarga de Documentos
            return <CC003 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "CC004": //=========> Revision de Analista
            return <CC004 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "CC005": //=========> Revision Referenciador
            return <CC005 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "CC006": //=========> Aprobacion Jefe
            return <CC006 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "CC007": //=========> Seleccion Codeudor
            return <CC007 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "CC008": //=========> PreAprobacion
            return <CC008 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "CC009": //=========> Aceptación Politicas
            return <CC009 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "CC010": //=========> Stepper Info
            return <CC010 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "CC011": //=========> Seleccion Analista
            return <CC011 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "CC012": //=========> Asingacion Token RequestCredit
            return <CC012 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />
        //Fomularios de Fabrica - Mantenimientos Diarios

        case "MD001": //=========> Formulario de mal funcionamiento en maquina
            return <MD001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "MD002": //=========> Asignación de Técnico a Cargo
            return <MD002 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "MD003": //=========> Revisión de la Maquina
            return <MD003 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "MD004": //=========> Validación del Mantenimiento Realizado
            return <MD004 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "MD005": //=========> Solicitud de Repuesto
            return <MD005 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "MD006": //=========> Validación de Repuesto
            return <MD006 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "MD007": //=========> Diagnostico de Daño
            return <MD007 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "MD008": //=========> Notificación Supervisor
            return <MD008 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "MD009": //=========> Solicitud de Materia Prima
            return <MD009 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "MD010": //=========> Entrada de Repuesto a Fabrica
            return <MD010 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "MD011": //=========> Entrada de Repuesto a Fabrica
            return <MD011 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "MD012": //=========> Formulario general de historial de mantenimientos
            return <MD012 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => pushProps(map)
            }} />

        // Formularios de Actualizacion de Ordenes de Pago

        case "AOP001": //=========> Formulario de Enturnar Documento Para Pago
            return <AOP001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        case "AOP002": //=========> Formulario de Seleccion de factura de venta por medio de Obligacion
            return <AOP002 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />

        //Formularios de varios usos
        case 'BPM001'://Formulario de Aprobación (OTP)
            return (
                <>
                    {procedure &&
                        <p>
                            <strong>Solicitud de: {procedure.AccountName}<br /> </strong> <small>{procedure.Description}</small><br />
                        </p>
                    }
                    {/* <PrintJson json={procedure} /> */}
                    <BPM001 procedure={procedureAction} exportMap={(data) => updateForm(data)} pushInfo={pushResumeInfo} pushProps={pushProps} />
                </>
            );

        case 'BPM002': //Formulario de Aprobación Básica
            return (
                <>
                    {procedure &&
                        <p>
                            <strong>Solicitud de: {procedure.AccountName}<br /> </strong> <small>{procedure.Description}</small><br />
                        </p>
                    }
                    {/* <PrintJson json={procedure} /> */}
                    <BPM002 procedure={procedureAction} exportMap={(data) => updateForm(data)} pushInfo={pushResumeInfo} pushProps={pushProps} />
                </>
            );

        case "BPM003"://Selector de Documento Presupuestal (IDDOcument)
            return <BPM003 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "BPM004": // Formulario de necesidad Basica PAA
            return <BPM004 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "BPM005":// Formulario de justificacion basica
            return <BPM005 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "BPM006": // Aprobacion basica con retorno de fase?
            return <BPM006 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "BPM007": //Solicitud de fimas /IDDocument
            return <BPM007 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "BPM008": //Cargue Documental Requisitos por Modalidad
            return <BPM008 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        //Solicitud de Vacante

        case "SCVA001":
            //Datos del  Tipo de Contrato para Contratacion de Vacante
            return <SCVA001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "SCVA002":
            //Formulario de Creacion de Tercero
            return <SCVA002 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "SCVA003":
            //Formulario de Creacion de Contrato por flujo de vacante
            return <SCVA003 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "SCVA004": //Aprobacion de slicitud de contratacion
            return <SCVA004 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;


        //Solicitud Capacitacion


        case "SOLCAP001": //Formulario de Solicitud de Capactiacion
            return <SOLCAP001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "SOLCAP002": //Aprobacion de solicitud de capacitacion
            return <SOLCAP002 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "THV001":
            //Formulario de Creacion de Tercero
            return <THV001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        // ============= mesa de ayuda =============
        case "HD001":
            return <HD001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;
        case "HD002":
            return <HD002 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;
        case "HD003":
            return <HD003 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "TEST001":
            return <TEST001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;
        case "TURNO001":
            return <TURNO001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;


        // ============= Solicitud de Nueva Necesidad =============
        case "SPAA001": //Formulario inicial
            return <SPAA001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "SPAA002": //Gestion de la Necesidad
            return <SPAA002 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "SPAA003": //Gestion de la Necesidad
            return <SPAA003 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;


        // ============= Solicitud de Autorizacion de Salida =============

        case "SOLAUTSAL001": //Formulario de soliciotud de salida
            return <SOLAUTSAL001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "SOLAUTSAL002": //Aprobacion de slicitud de salida
            return <SOLAUTSAL002 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "SOLAUTSAL003": //Verificacion y descargue de Documento
            return <SOLAUTSAL003 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "SOLAUTSAL004": //Confirmacion de devolucion de inventarios
            return <SOLAUTSAL004 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        // Cargue de documentacion contractual ARCONCO =>FORPO

        case "ARCON001": //Cargue Documental genereico de Requisitos por Modalidad
            return <ARCON001 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        case "ARCON002": //Asignacion de lista de RP a contrato
            return <ARCON002 configProcedure={{
                _exportMap: (data) => updateForm(data),
                _procedure: procedureAction,
                _pocessData: process,
                _pushInfo: (map) => { pushResumeInfo(map) },
                _pushProps: (map) => { pushProps(map) }
            }} />;

        // ============= mesa de ayuda =============

        // Render Forpo
        // case 'TKP01':
        //     return (
        //         <TokenAssign procedure={{}} exportMap={(data: any) => {
        //             //console.log(data);
        //             responseAction(data)
        //         }} />
        //     )
        // case 'APP01':
        //     return (
        //         <AproveOrder affiliate={afiliate} credit={credit} title='Aprobación del Orden del gasto' message={""} exportMap={(data: any) => {
        //             //console.log(data);
        //             responseAction(data)
        //         }} />
        //     )
        // case 'PT001':
        //     return (
        //         <RequestToken
        //             updateCredit={(bean: any) => { update(bean) }}
        //             _credit={credit}
        //             title='Registrar token portal tercero'
        //             message={"Ingrese el token generado"}
        //             exportMap={(data: any) => {
        //                 //console.log(data);
        //                 responseAction(data)
        //             }}
        //             _user={afiliate}
        //         />
        //     )
        // case 'PT002':
        //     return (
        //         <SaveToken
        //             closeModal={() => { closeModal() }} updateCredit={(bean: any) => { update(bean) }}
        //             affiliate={afiliate}
        //             credit={credit}
        //             title='Grabar token portal tercero'
        //             message={"Ingrese a portal terceros y grabe el token generado"}
        //             exportMap={(data: any) => {
        //                 //console.log(data);
        //                 responseAction(data)
        //             }} />
        //     )
        // case "PT003":
        //     return (
        //         <ValidationSIIF procedure={{}} title='Validar Cuenta de Usuario en SIIF' message={"Validar si la cuenta del usuario que esta solicitando el credito se encuentra en SIIF"} exportMap={(data: any) => {
        //             //console.log(data);
        //             responseAction(data)
        //         }} />
        //     )

        default:
            return (<RenderForm idFormType={901} handleUpdate={(data) => updateForm(data)} />);
    }
};
